import { createCompoundComponent } from '../../utilities'

import { ExpandableText as BaseExpandableText } from './ExpandableText'
import { Content } from './Content'
import { Trigger } from './Trigger'

export const ExpandableText = createCompoundComponent(BaseExpandableText, {
  Content,
  Trigger,
})

export { useExpandableTextContext } from './ExpandableText'
export type * from './types'
